<template>
  <admin-catastro :catastroSelect="catastroSelected"></admin-catastro>
</template>

<script>
import AdminCatastro from "./admin-catastro";

export default {
  name: "AdminInmueblesEdit",
  components: {
    AdminCatastro
  },
  data() {
    return {
      // path: null
    };
  },
  watch: {},
  created() {
    // this.seleccionarCatastro()
    // this.path = this.$route
  },
  computed: {
    catastroSelected() {
      const idx = this.$route.params.id;
      if (idx) {
        return idx;
      }
      return "";
      // this.expedienteSelected = this.$store.getters.getExpedienteSelected(idx)
    }
  },
  methods: {}
};
</script>
